import { createTheme } from '@mui/material/styles';
import { colors } from './WebTheme';



const theme = createTheme({
    palette: {
        primary: {
            main: colors.Primary,
        },
    },
    components: {
        MuiTab: {
            styleOverrides: {
                root: {
                    color: colors.Text,
                    marginRight: '16px',
                    '&.Mui-selected': {
                        color: colors.Primary,
                        fontWeight: 'bold',
                    },
                    '&.Mui-focusVisible': {
                        outline: `2px solid ${colors.Primary}`,
                        outlineOffset: '2px',
                    },
                },
            },
        },
        MuiTabs: {
            styleOverrides: {
                indicator: {
                    backgroundColor: colors.Primary,
                },
            },
        },

    },
});

export default theme;
